import { convertBreakToNewLine } from "@/utilities/helpers"
import parse from "html-react-parser"
import React from "react"
import { up } from "styled-breakpoints"
import styled, { css } from "styled-components"

export type HeadingSizes = "cta" | "h1" | "h2" | "h3" | "h4" | "hero"
export type TitleTags = "h1" | "h2" | "h3" | "h4" | "h5" | "h6"

export interface IHeading {
  center?: boolean
  className?: string
  preLine?: boolean
  size?: HeadingSizes
  splitNewline?: boolean
  title?: string
  titleTag?: TitleTags
  whiteGradient?: boolean
}

const HeadingWrapper = styled.div<IHeading>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: auto;
  padding: 0;
  margin: 0;
  font-style: normal;
  font-weight: 600;
  color: white;
  text-align: left;

  ${(props) =>
    props.center &&
    css`
      align-items: center;
      max-width: 100%;
      margin: 0 auto;
      text-align: center;
    `}

  ${(props) =>
    props.whiteGradient &&
    css`
      background: linear-gradient(#fff 33.85%, #d7d7d7 100%);
      background-clip: text;
      /* stylelint-disable-next-line */
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    `}

    ${(props) =>
    props.preLine &&
    css`
      white-space: pre-line;
    `}


    ${(props) => {
    if (props.size === "hero") {
      return css`
        font-size: 36px;
        line-height: 44px; /* 109.524% */
        letter-spacing: -0.72px;

        /* stylelint-disable no-duplicate-selectors */
        ${up("md")} {
          font-size: 64px;
          line-height: 68px;
          letter-spacing: -1.3px;
        }

        ${up("lg")} {
          font-size: 84px;
          line-height: 92px; /* 109.524% */
          letter-spacing: -1.7px;
        }
      `
    } else if (props.size === "h1") {
      return css`
        font-size: 64px;
        line-height: 68px; /* 106.25% */
        letter-spacing: -1.28px;
      `
    } else if (props.size === "h2") {
      return css`
        font-size: 28px;
        line-height: 36px;
        letter-spacing: -0.56px;

        ${up("md")} {
          font-size: 40px;
          line-height: 48px; /* 120% */
          letter-spacing: -0.4px;
        }
      `
    } else if (props.size === "h3") {
      return css`
        font-size: 22px;
        line-height: 26.4px;

        ${up("md")} {
          font-size: 32px;
          line-height: 40px; /* 125% */
          letter-spacing: -0.64px;
        }
      `
    } else if (props.size === "h4") {
      return css`
        font-size: 24px;
        line-height: 40px; /* 166.667% */
        letter-spacing: -0.48px;
      `
    } else if (props.size === "cta") {
      return css`
        font-size: 32px;
        font-weight: 600;
        font-feature-settings: "ss01" on;
        line-height: 40.3px;

        ${up("md")} {
          font-size: 48px;
          line-height: 56px; /* 116.667% */
        }
      `
    }
  }}
`

const Heading: React.FC<IHeading> = (props) => {
  return (
    <HeadingWrapper
      as={props.titleTag || "h3"}
      center={props.center || false}
      className={props.className}
      preLine={props.preLine || false}
      size={props.size || "h3"}
      whiteGradient={props.whiteGradient || false}>
      {parse(convertBreakToNewLine(props.title, props.splitNewline) ?? "")}
    </HeadingWrapper>
  )
}

export default Heading
